import chroma from 'chroma-js';

export const dark = (hex = '#000') => chroma(hex).get('lab.l') < 60;

export const darken = (hex = '#000', distance = 2.8) => chroma(hex).darken(distance).get('hex');

export const lighten = (hex = '#000', distance = 2.8) => chroma(hex).brighten(distance).get('hex');

export const alpha = (hex = '#000', distance = 1) => chroma(hex).alpha(distance).css();
